import { Candidate } from "../../models/Candidate";

interface Props {
    candidate: Candidate;
    preferredSectors: String[];
    styles: any;
}

export const InfoTab: React.FC<Props> = (props) => {
    const styles = props.styles;  

    return (
        <div style={styles.mainWrapper}>
            <p style={styles.title}>Info</p>
            <div style={styles.details}>
                {props.candidate.linkedInUrl !== "" && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"LinkedIn Url"}</div>
                    <div style={styles.details.text}>{props.candidate.linkedInUrl}</div>
                </div>}
                {props.candidate.location && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Preferred Locations"}</div>
                    <div style={styles.details.text}>{props.candidate.location}</div>
                </div>}
                {(props.preferredSectors && props.preferredSectors!.length > 0) && <div style={styles.details.box}>
                    <div style={{...styles.details.title, ...styles.details.title.preferredSectors}}>{"Preferred Sectors"}</div>
                    <div style={styles.details.text}>
                        {props.preferredSectors!.map((sector, index) => (
                            <div key={index} style={styles.details.sector}>{sector}</div>
                        ))}
                    </div>
                </div>}
                {props.candidate.additionalQualifications && <>
                    <div style={styles.details.qualifications}>{"Qualifications"}</div>
                    <div style={styles.details.box}>
                        <div style={styles.details.text}>{props.candidate.additionalQualifications}</div>
                    </div>
                </>}
            </div>
        </div>
    )
}